import { Button } from './ui/button';
import { InfoIcon, AlertTriangle } from 'lucide-react';
import { useState } from 'react';
import classNames from 'classnames';
import { formatLastRefundTimeStamp } from '../utils/formatLastRefundTimeStamp';

interface Props {
  lastRefundTimestamp: number;
}

function Terms({ dateString }: { dateString: string }) {
  return (
    <div className="flex flex-col gap-2 rounded-md border border-gray-200 p-4 text-sm">
      <p>
        No refunds will be issued after{' '}
        <span className="font-medium">{dateString}</span>.
      </p>
      <p>
        Any cancellation requests must be submitted before this date to be
        eligible for a refund. After{' '}
        <span className="font-medium">{dateString}</span>, all payments are
        considered final.
      </p>
      <p>
        Cancellations must be made by unregistering the participant. Please
        ensure that all changes are processed through this registration system
        to confirm your cancellation.
      </p>
    </div>
  );
}

export function LastRefund({ lastRefundTimestamp }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const canRefund = lastRefundTimestamp > Date.now();
  const dateString = formatLastRefundTimeStamp(lastRefundTimestamp);

  return (
    <div className="flex flex-col items-end gap-2">
      {canRefund && (
        <Button variant="link" onClick={() => setIsOpen(!isOpen)}>
          <InfoIcon className="h-4 w-4" />
          Final refund date: {dateString}
        </Button>
      )}
      {!canRefund && (
        <Button
          variant="link"
          onClick={() => setIsOpen(!isOpen)}
          className="text-red-500"
        >
          <AlertTriangle className="h-4 w-4" />
          Final refund date: {dateString}
        </Button>
      )}
      <div
        className={classNames(
          'overflow-hidden transition-all duration-200 ease-in-out',
          isOpen ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0',
        )}
      >
        <Terms dateString={dateString} />
      </div>
    </div>
  );
}
